module.exports = __webpack_public_path__ + "img/web1.6269c025.png";